import React, { useRef } from 'react';
import { Button } from 'primereact/button';

const SelectableSubFieldWrapper = ({ children, removeItem, highlighted, item, handleSettingsClick }) => {
  const wrapperRef = useRef(null);

  const disableSettings = !(item?.type === 'divider');

  const disableDelete = !(item?.type === 'name' || item?.type === 'role');

  return (
    <div ref={wrapperRef} className={`mt-1 selectable-wrapper grabbable  ${highlighted ? 'sub-field-highlight' : ''}`}>
      {highlighted && (
        <div className="icon-group appear-animation">
          {disableSettings && (
            <Button
              icon="pi pi-cog"
              tooltip="Settings"
              tooltipOptions={{ position: 'top', showDelay: 250 }}
              className="selectable-button sm-button p-button-text settings-button"
              onClick={() => handleSettingsClick(item)}
            />
          )}
          {disableDelete && (
            <Button
              icon="pi pi-trash"
              tooltip="Delete"
              tooltipOptions={{ position: 'top', showDelay: 250 }}
              className="selectable-button sm-button p-button-text delete-button"
              onClick={removeItem}
            />
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default SelectableSubFieldWrapper;
